(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('.lf-thumbnails button')];
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      let current = Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
      const update = (index, scroll) => {
        current = Math.max(0, Math.min(thumbs.length - 1, index));
        const selected = thumbs[current];
        if (!selected) return;
        if (track && slides[current]) {
          if (scroll) track.scrollTo({left: slides[current].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        } else if (selected.dataset.image) {
          const requestedIndex = current;
          const img = document.createElement('img');
          img.alt = selected.dataset.alt || 'Product image';
          img.decoding = 'async';
          let shown = false;
          const show = () => {
            if (shown || current !== requestedIndex) return;
            shown = true;
            gallery.querySelector('[data-gallery-main]').replaceChildren(img);
          };
          img.addEventListener('load', show, { once: true });
          img.src = selected.dataset.image;
          if (img.complete && img.naturalWidth) show();
        }
        thumbs.forEach(b => b.setAttribute('aria-pressed', String(b === selected)));
        const thumbnailTrack = gallery.querySelector('.lf-thumbnails');
        thumbnailTrack.scrollTo({left: selected.offsetLeft - thumbnailTrack.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === thumbs.length - 1;
      };
      const select = index => update(index, true);
      if (previous) previous.addEventListener('click', () => select(current - 1));
      if (next) next.addEventListener('click', () => select(current + 1));
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = thumbs.length < 2;
      gallery.addEventListener('click', event => {
        const button = event.target.closest('.lf-thumbnails button');
        if (!button) return;
        select(thumbs.indexOf(button));
      });
      const main = gallery.querySelector('[data-gallery-main]');
      if (track && slides.length > 1) {
        let scrollFrame = 0;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            let nearest = 0;
            let distance = Infinity;
            slides.forEach((slide, index) => {
              const nextDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
              if (nextDistance < distance) { distance = nextDistance; nearest = index; }
            });
            update(nearest, false);
          });
        }, { passive: true });
      } else if (main && thumbs.length > 1) {
        let touchStartX = 0;
        let touchStartY = 0;
        main.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', event => {
          const touch = event.changedTouches[0];
          if (!touch) return;
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
          select(current + (deltaX < 0 ? 1 : -1));
        }, { passive: true });
      }
      update(current, false);
    });
    root.querySelectorAll('[data-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-track]');
      const prev = carousel.querySelector('[data-prev]');
      const next = carousel.querySelector('[data-next]');
      const sync = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      const move = direction => track.scrollBy({ left: direction * (track.firstElementChild.getBoundingClientRect().width + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(track);
      sync();
    });
    root.querySelectorAll('.lf-demo-offers').forEach(offers => {
      if (!offers.querySelector('input:checked')) { const first = offers.querySelector('input'); if (first) first.checked = true; }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.lf-menu[open]').forEach(menu => menu.removeAttribute('open')); });
})();
